import React from 'react';

export const Logo = ({ height = 50, dark = false }) => {
  const scale = height / 50;
  const width = Math.round(280 * scale);
  const textFill = dark ? '#2A2A2A' : '#FFFFFF';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 280 60"
      xmlns="http://www.w3.org/2000/svg"
      className="overflow-visible"
    >
      {/* Soundwave bars - original cyan */}
      <rect x="12" y="21" width="4" height="18" fill="#00FFD1" rx="2">
        <animate attributeName="height" values="18;26;18" dur="1.5s" repeatCount="indefinite" />
        <animate attributeName="y" values="21;17;21" dur="1.5s" repeatCount="indefinite" />
      </rect>
      <rect x="21" y="16" width="4" height="28" fill="#00FFD1" rx="2">
        <animate attributeName="height" values="28;36;28" dur="1.3s" repeatCount="indefinite" />
        <animate attributeName="y" values="16;12;16" dur="1.3s" repeatCount="indefinite" />
      </rect>
      <rect x="30" y="12" width="4" height="36" fill="#00FFD1" rx="2">
        <animate attributeName="height" values="36;42;36" dur="1.1s" repeatCount="indefinite" />
        <animate attributeName="y" values="12;9;12" dur="1.1s" repeatCount="indefinite" />
      </rect>
      <rect x="39" y="8" width="4" height="44" fill="#00FFD1" rx="2">
        <animate attributeName="height" values="44;50;44" dur="0.9s" repeatCount="indefinite" />
        <animate attributeName="y" values="8;5;8" dur="0.9s" repeatCount="indefinite" />
      </rect>
      <rect x="48" y="10" width="4" height="40" fill="#00FFD1" rx="2">
        <animate attributeName="height" values="40;46;40" dur="1.2s" repeatCount="indefinite" />
        <animate attributeName="y" values="10;7;10" dur="1.2s" repeatCount="indefinite" />
      </rect>
      <rect x="57" y="15" width="4" height="30" fill="#00FFD1" rx="2">
        <animate attributeName="height" values="30;36;30" dur="1.4s" repeatCount="indefinite" />
        <animate attributeName="y" values="15;12;15" dur="1.4s" repeatCount="indefinite" />
      </rect>
      <rect x="66" y="18" width="4" height="24" fill="#00FFD1" rx="2">
        <animate attributeName="height" values="24;30;24" dur="1.6s" repeatCount="indefinite" />
        <animate attributeName="y" values="18;15;18" dur="1.6s" repeatCount="indefinite" />
      </rect>
      <rect x="75" y="12" width="4" height="36" fill="#00FFD1" rx="2">
        <animate attributeName="height" values="36;42;36" dur="1.0s" repeatCount="indefinite" />
        <animate attributeName="y" values="12;9;12" dur="1.0s" repeatCount="indefinite" />
      </rect>
      <rect x="84" y="8" width="4" height="44" fill="#00FFD1" rx="2">
        <animate attributeName="height" values="44;50;44" dur="0.8s" repeatCount="indefinite" />
        <animate attributeName="y" values="8;5;8" dur="0.8s" repeatCount="indefinite" />
      </rect>
      <rect x="93" y="12" width="4" height="36" fill="#00FFD1" rx="2">
        <animate attributeName="height" values="36;40;36" dur="1.1s" repeatCount="indefinite" />
        <animate attributeName="y" values="12;10;12" dur="1.1s" repeatCount="indefinite" />
      </rect>
      <rect x="102" y="18" width="4" height="24" fill="#00FFD1" rx="2">
        <animate attributeName="height" values="24;28;24" dur="1.3s" repeatCount="indefinite" />
        <animate attributeName="y" values="18;16;18" dur="1.3s" repeatCount="indefinite" />
      </rect>
      <rect x="111" y="21" width="4" height="18" fill="#00FFD1" rx="2">
        <animate attributeName="height" values="18;24;18" dur="1.5s" repeatCount="indefinite" />
        <animate attributeName="y" values="21;18;21" dur="1.5s" repeatCount="indefinite" />
      </rect>

      {/* Text - Original Orbitron font, white text */}
      <text x="130" y="40" fill={textFill} fontSize="22" fontWeight="700" fontFamily="'Orbitron', sans-serif" letterSpacing="2">
        HIBOTICS AI
      </text>
    </svg>
  );
};
